module.exports = __webpack_public_path__ + "img/coinbase.8b5c559a.png";